// Get the menu element
const menus = document.querySelectorAll('.wp-block-navigation > li > ul > li');
// Handle Mobile Menu
const menuMobileBtn = document.querySelector('.nav-primary--mobile > button')
const menuMobile = document.querySelector('.nav-primary--mobile > .wp-block-navigation__responsive-container ')
const submenuBtn = document.querySelectorAll('header .wp-block-navigation-submenu__toggle')
const searchBtn = document.querySelector('header .wp-block-create-block-search-form .search-form__control')
const searchInput = document.querySelector('header .wp-block-create-block-search-form .search-form .search-form__fields')
const searchForm = document.querySelector('header .wp-block-create-block-search-form .search-form')
// Handle Footer Menu
const menuFooterLi = document.querySelector('.nav-footer > li')
const menuFooterBtn = document.querySelectorAll('.nav-footer .wp-block-navigation-item.has-child .wp-block-navigation-submenu__toggle')

if (menus) {
  menus.forEach(item => {
    const btn = item.querySelector('.wp-block-navigation__submenu-icon');
    const ul = item.querySelector('.wp-block-navigation-submenu');
    if (ul && btn) {
      item.removeChild(btn);
      item.removeChild(ul);
      item.setAttribute('class', 'wp-block-navigation-item wp-block-navigation-link');
    }
  });
}

if (submenuBtn) {
  submenuBtn.forEach(item => {
    var childmenu = item.parentNode.querySelector('.wp-block-navigation__submenu-container');
    item.removeAttribute('data-wp-on--click')
    // item.removeAttribute('data-wp-bind--aria-expanded')
    // item.removeAttribute('aria-expanded')
    if (childmenu) {
      item.addEventListener("click", function handleClick(e) {
        if (childmenu.classList.contains('open')) {
          item.classList.remove('open')
          childmenu.classList.remove('open')
          item.parentNode.classList.remove('open')
        } else {
          item.classList.add('open')
          childmenu.classList.add('open')
          item.parentNode.classList.add('open')
        }
      })
    }
  })
}

if (menuMobileBtn) {
  menuMobileBtn.removeAttribute('data-wp-on--keydown')
  menuMobileBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M5 8.16467H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/><path d="M5 12.1647H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/><path d="M5 16.1647H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/></svg>'
  menuMobileBtn.removeAttribute('data-wp-on-async--click')
  menuMobileBtn.removeAttribute('data-wp-on--click')
  
  menuMobileBtn.addEventListener("click", function handleClick(event) {
    if(event.target.classList.contains('wp-block-navigation__responsive-container-open')){
      event.target.classList.remove('wp-block-navigation__responsive-container-open')
      event.target.classList.add('wp-block-navigation__responsive-container-close')
      // event.target.setAttribute('data-wp-on--click', 'actions.core.navigation.closeMenuOnClick')
      event.target.setAttribute('aria-label', 'Close menu')
      event.target.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 6.57467L18.09 5.16467L12.5 10.7547L6.91 5.16467L5.5 6.57467L11.09 12.1647L5.5 17.7547L6.91 19.1647L12.5 13.5747L18.09 19.1647L19.5 17.7547L13.91 12.1647L19.5 6.57467Z" fill="white"/></svg>'
      menuMobile.classList.add('is-menu-open')
    }else{
      event.target.classList.add('wp-block-navigation__responsive-container-open')
      event.target.classList.remove('wp-block-navigation__responsive-container-close')
      // event.target.setAttribute('data-wp-on--click', 'actions.core.navigation.openMenuOnClick')
      event.target.setAttribute('aria-label', 'Open menu')
      event.target.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M5 8.16467H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/><path d="M5 12.1647H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/><path d="M5 16.1647H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/></svg>'
      menuMobile.classList.remove('is-menu-open')
    }

    if (submenuBtn) {
      submenuBtn.forEach(item => {
        var childmenu = item.parentNode.querySelector('.wp-block-navigation__submenu-container');
        if (childmenu) {
          item.classList.remove('open')
          childmenu.classList.remove('open')
        }
      })
    }

    if (searchInput && searchBtn) {
      searchInput.classList.remove('open')
      searchBtn.classList.remove('active')
    }
  });
}

if (searchBtn) {
  searchBtn.addEventListener("click", function handleClick(event) {
    event.preventDefault()
    searchInput.classList.toggle('open')
    searchBtn.classList.toggle('active')
    searchInput.querySelector('input').focus()

    menuMobileBtn.classList.add('wp-block-navigation__responsive-container-open')
    menuMobileBtn.classList.remove('wp-block-navigation__responsive-container-close')
    menuMobileBtn.setAttribute('data-wp-on--click', 'actions.core.navigation.openMenuOnClick')
    menuMobileBtn.setAttribute('aria-label', 'Open menu')
    menuMobileBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M5 8.16467H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/><path d="M5 12.1647H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/><path d="M5 16.1647H20" stroke="#212121" stroke-width="1.5" stroke-linecap="round"/></svg>'
    menuMobile.classList.remove('is-menu-open')
  })
}

// if(searchInput){
//   searchInput.addEventListener("keyup", function(event){
//     if(event.key === 'Enter'){
//       searchForm.submit()
//     }
//   })
// }

if (menuFooterLi) {
  menuFooterLi.removeAttribute('data-wp-on--keydown')
  menuFooterBtn.forEach(item => {
    var childmenu = item.parentNode.querySelector('.wp-block-navigation__submenu-container');
    item.removeAttribute('data-wp-on--keydown')
    item.removeAttribute('data-wp-on--click')
    // item.removeAttribute('data-wp-bind--aria-expanded')
    // item.removeAttribute('aria-expanded')
    if(childmenu){
        item.addEventListener("click", function handleClick(e) {
            if(childmenu.classList.contains('open')){
                item.classList.remove('open')
                childmenu.classList.remove('open')
                // item.parentNode.classList.remove('open')
            }else{
                item.classList.add('open')
                childmenu.classList.add('open')
                // item.parentNode.classList.add('open')
            }
        })
    }
})
}

// NECAOS-440: Highlight current menu item
const navigationLinks = document.querySelectorAll('.wp-block-navigation-item.wp-block-navigation-link');

if (navigationLinks) {
  navigationLinks.forEach(item => {
    if (item.classList.contains('current-menu-item')) return;

    const link = item.querySelector('a');
    if (link && link.href === window.location.href) {
      item.classList.add('current-menu-item');
    }
  });
}